interface Iprops {
  width: number;
  height: number;
}

export const PlusIcon = ({ width, height }: Iprops) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 8H14M8 14V2"
        stroke="#FCFDFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
